import { PopOver } from "../../components";
import { Text, View } from "react-native";
import Button from "../../components/Button";
import { formatDate } from "../../utils/dateUtils";

export function AssessmentNotice({
  visible,
  onDismiss,
  videoStatus,
  completedDate,
}: {
  visible: boolean;
  onDismiss(): void;
  onContinue(): void;
  videoStatus: string;
  completedDate: string;
}) {
  const isCompleted = videoStatus === "Completed";
  const isUnavailable = videoStatus === "Unavailable";

  let headerText = "Complete the video to proceed to the assessment.";
  let bodyText = "The video must be watched in its entirety before proceeding to the assessment.";

  if (isCompleted) {
    headerText = "Assessment completed.";
    bodyText = `You successfully passed this assessment on ${formatDate(completedDate, "MMM D, yyyy")}.`;
  } else if (isUnavailable) {
    headerText = "Assessment attempts exceeded.";
    bodyText = "You have exceeded the maximum of 2 attempts to pass this assessment.";
  }

  return (
    <PopOver {...{ visible, onDismiss }} testID="assessment-notice-popover">
      <View className="items-center">
        <Text className="text-title-5 font-700 mb-2 text-center">{headerText}</Text>
        <Text className="text-regular-normal font-400 mt-2 mb-2 text-center">{bodyText}</Text>
        <View className="w-full mt-6">
          <Button mode="secondary" onPress={onDismiss} className="w-full">
            Close
          </Button>
        </View>
      </View>
    </PopOver>
  );
}
